import { crrem_version_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCrremVersionTypeEnum = (enumValue: crrem_version_type_enum) => {
  switch (enumValue) {
    case crrem_version_type_enum.V2_05:
      return <Trans i18nKey="Enum_CrremVersionTypeEnum-V2_05" />;
    case crrem_version_type_enum.V2_07:
      return <Trans i18nKey="Enum_CrremVersionTypeEnum-V2_07" />;
  }
};

export const translateCrremVersionTypeEnum_dynamic = (enumValue: crrem_version_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case crrem_version_type_enum.V2_05:
      return t('Enum_CrremVersionTypeEnum-V2_05');
    case crrem_version_type_enum.V2_07:
      return t('Enum_CrremVersionTypeEnum-V2_07');
  }
};
